import { render, staticRenderFns } from "./Whitedraw.vue?vue&type=template&id=56ca1416&scoped=true&"
import script from "./Whitedraw.vue?vue&type=script&lang=js&"
export * from "./Whitedraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca1416",
  null
  
)

export default component.exports